<template>
	<div
		class="group/item pb-4 xl:pb-0 h-auto xl:h-32 flex items-center"
	>
		<AtomLink
			v-bind="item.to"
			:class="[
				'flex items-center gap-3 py-2 px-4 rounded-full transition-colors duration-200',
				'border border-transparent group-hover/item:border-purple-400',
				'group-hover/item:bg-purple-300 group-hover/item:text-purple-800',
			]"
			@click="emit('navigate')"
		>
			{{ item.text }}
			<span
				v-if="counter"
				class="rounded-full size-8 bg-red-400 text-white text-center inline-flex items-center justify-center"
			>
				{{ counter }}
			</span>
			<AtomFontAwesome
				v-if="!!item.submenu && item.submenu.items.length > 0"
				icon="fa-chevron-down"
				class="size-4"
			/>
		</AtomLink>
		<SubMenu
			v-if="!!item.submenu && item.submenu.items.length > 0"
			v-bind="item.submenu"
			@navigate="$emit('navigate')"
		/>
	</div>
</template>

<script lang="ts" setup>
import SubMenu from './SubMenu.vue';
import type { MainMenuItemType } from '#base/core/types/MainMenuItemType';

const {
	item,
} = defineProps<{
	item: MainMenuItemType;
}>();

const emit = defineEmits(['navigate']);

const counter = ref<number>();

onMounted(async () => {
	if (!item.counter) {
		return;
	}

	if (typeof item.counter === 'number') {
		counter.value = item.counter;

		return;
	}

	counter.value = await item.counter;
});
</script>
